var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"act-paoma",style:(_vm.wrapStyle)},[_c('transition',{attrs:{"name":"fade"}},_vm._l((_vm.records),function(item,index){return (index === _vm.current_show)?_c('div',{key:index,staticClass:"item",style:(_vm.itemStyle)},[_vm._v("\n      "+_vm._s(item)+"\n    ")]):_vm._e()}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7468c09c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfigUI/ActPaomadeng.vue
// module id = null
// module chunks = 